"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var game_1 = require("./game");
exports.rootReducer = redux_1.combineReducers({
    game: game_1.gameReducer
});
function createStore() {
    return redux_1.createStore(exports.rootReducer);
}
exports.createStore = createStore;
